let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kIyd3")).then(() => parcelRequire('lzA6o'));